import { toMoment } from 'api/helpers';
import { sortArray } from 'utils/helpers';
import DropShip from './DropShip';
import OrderType from './OrderType';
import he from 'he';

export default class Cart {
	static formatDate = date => (date.isValid() ? date.format('MM-DD-YYYY') : '');

	items = {
		category_end_date: '',
		category_id: 0,
		category_name: '',
		end_date: '',
		est_ship_date: '',
		est_ship_date_for_cart: '',
		id: 0,
		price_list: null,
		total_config_qty_ordered: 0,
		category_promotion_class_id: 0,
		quantity_available: 0,
		promo_no_of_days: null,
		image_url: null,
		order_type: null,
		initial_order_type: null,
		is_configurable: false,
		drop_ship: null,
		is_pack: false,
		is_drop_ship: false,
		is_preview: false,
		list_price: 0,
		name: '',
		db_item_name: '',
		number: '',
		pack_id: 0,
		promo_price: 0,
		ext_price: 0,
		promotion_end_date: '',
		promotion_id: 0,
		promotion_name: '',
		quantity: 0,
		quantity_ordered: 0,
		initial_quantity_ordered: 0,
		start_date: '',
		ta: 0,
		base_number: '',
		quantity_in_cart: 0,
		configurations: [],
		item_description: '',
		current_order_type: null,
		current_drop_ship_address: null,
		category_ship_type_id: 0,
		category_ship_type_name: '',
	};
	total_promo_price = 0;
	total_ext_price = 0;
	drop_ships = [];
	order_types = [];

	constructor(cart) {
		if (cart) {
			this.items = cart.Items.map(item => ({
				category_end_date: toMoment(item.ItemDetails.CategoryEndDate),
				category_id: item.ItemDetails.CategoryId,
				category_name: item.ItemDetails.CategoryName,
				end_date: toMoment(item.ItemDetails.EndDate),
				est_ship_date: toMoment(item.ItemDetails.EstShipDate),
				est_ship_date_for_cart: toMoment(item.ItemDetails.EstShipDateForCart),
				id: item.ItemDetails.Id,
				total_config_qty_ordered: item.ItemDetails.TotalConfigQtyOrdered,
				pack_name: item.ItemDetails.IsPack ? item.ItemDetails.PackName : null,
				category_promotion_class_id: item.ItemDetails.CategoryPromotionClassId,
				quantity_available: item.ItemDetails.QuantityAvailable,
				promo_no_of_days: item.ItemDetails.PromoNoOfDays,
				image_url: item.ItemDetails.ImageUrl,
				price_list: item.ItemDetails.PriceList,
				order_type: item.ItemDetails.OrderType
					? new OrderType(item.ItemDetails.OrderType)
					: null,
				initial_order_type: item.ItemDetails.InitialOrderType
					? new OrderType(item.ItemDetails.InitialOrderType)
					: null,
				current_order_type: item.ItemDetails.OrderType
					? new OrderType(item.ItemDetails.OrderType)
					: null,
				is_configurable: item.ItemDetails.IsConfigurable,
				is_drop_ship: item.ItemDetails.IsDropShipAllowed,
				drop_ship_address: item.ItemDetails.DropShip
					? new DropShip(item.ItemDetails.DropShip)
					: null,
				initial_drop_ship_address: item.ItemDetails.InitialDropShip
					? new DropShip(item.ItemDetails.InitialDropShip)
					: null,
				current_drop_ship_address: item.ItemDetails.DropShip
					? new DropShip(item.ItemDetails.DropShip)
					: null,
				is_pack: item.ItemDetails.IsPack,
				is_preview: item.ItemDetails.IsPreview,
				list_price: item.ItemDetails.ListPrice,
				name: he.decode(item.ItemDetails.Name),
				db_item_name: item.ItemDetails.Name,
				number: item.ItemDetails.Number,
				pack_id: item.ItemDetails.PackId,
				promo_price: item.ItemDetails.PromoPrice,
				ext_price: item.ItemDetails.ExtPrice,
				promotion_end_date: toMoment(item.ItemDetails.PromotionEndDate),
				promotion_id: item.ItemDetails.PromotionId,
				promotion_name: item.ItemDetails.PromotionName,
				quantity: item.ItemDetails.Quantity,
				quantity_ordered: item.QuantityInCart,
				initial_quantity_ordered: item.QuantityInCart,
				start_date: toMoment(item.ItemDetails.StartDate),
				ta: item.ItemDetails.TA,
				base_number: item.ItemDetails.BaseNumber,
				quantity_in_cart: item.QuantityInCart,
				configurations: item.ItemDetails.IsConfigurable
					? item.ItemDetails.Configurations.map(conf => ({
							id: conf.Id,
							quantity_ordered: conf.QuantityOrdered,
							number: conf.ItemNumber,
							base_number: conf.BaseNumber,
							image_url: conf.ImageUrl,
						}))
					: null,
				item_description: item.ItemDetails.ItemDescription,
				offerings: item.ItemDetails.IsPack
					? sortArray(item.ItemDetails.Items, 'Number').map(item => ({
							id: item.Id,
							promo_no_of_days: item.PromoNoOfDays,
							price_list: item.PriceList,
							price: item.Price,
							image_url: item.ImageUrl,
							base_number: item.BaseNumber,
							number: item.Number,
							order_type: new OrderType(item.OrderType),
							quantity: item.Quantity,
							is_configurable: item.IsConfigurable,
							item_description: item.ItemDescription,
							net_price: item.NetPrice,
							est_ship_date: toMoment(item.EstShipDate),
							promo_price: item.PromoPrice,
							is_drop_ship_allowed: item.IsDropShipAllowed,
						}))
					: null,
				category_ship_type_id: item.ItemDetails.CategoryShipTypeId,
				category_ship_type_name: item.ItemDetails.CategoryShipTypeName,
			}));
			this.total_promo_price = cart.TotalPromoPrice;
			this.total_ext_price = cart.TotalExtPrice;
			this.drop_ships = cart.DropShips
				? cart.DropShips.map(dropShip => new DropShip(dropShip))
				: null;
			this.order_types = cart.OrderTypes
				? cart.OrderTypes.map(orderType => new OrderType(orderType))
				: null;
		}
	}

	serialize(item) {
		return {
			CategoryEndDate: Cart.formatDate(item.category_end_date),
			CategoryId: item.category_id,
			CategoryName: item.category_name,
			IsDropShipAllowed: item.is_drop_ship,
			DropShip: item.drop_ship_address
				? new DropShip().serialize(item.drop_ship_address)
				: null,
			InitialDropShip: item.initial_drop_ship_address
				? new DropShip().serialize(item.initial_drop_ship_address)
				: null,
			EndDate: Cart.formatDate(item.end_date),
			EstShipDate: item.is_pack
				? item.est_ship_date
				: Cart.formatDate(item.est_ship_date),
			EstShipDateForCart: Cart.formatDate(item.est_ship_date_for_cart),
			OrderType: new OrderType().serialize(item.order_type),
			InitialOrderType: new OrderType().serialize(item.initial_order_type),
			IsConfigurable: item.is_configurable,
			IsPack: item.is_pack,
			IsPreview: item.is_preview,
			Id: item.id,
			PriceList: item.price_list,
			ImageUrl: item.image_url,
			ListPrice: item.list_price,
			Name: item.db_item_name,
			NetPrice: item.net_price,
			Number: item.number,
			BaseNumber: item.base_number,
			PackId: item.pack_id,
			PromoPrice: item.promo_price,
			PromotionEndDate: Cart.formatDate(item.promotion_end_date),
			PromotionId: item.promotion_id,
			PromotionName: item.promotion_name,
			Quantity: item.quantity,
			QuantityOrdered: item.quantity_ordered,
			InitialQuantityOrdered: item.initial_quantity_ordered,
			PackTitle: item.pack_name,
			PromoNoOfDays: item.promo_no_of_days,
			StartDate: Cart.formatDate(item.start_date),
			TA: item.ta,
			TotalConfigQtyOrdered: item.total_config_qty_ordered,
			CategoryPromotionClassId: item.category_promotion_class_id,
			QuantityAvailable: item.quantity_available,
			Configurations: item.is_configurable
				? item.configurations.map(conf => ({
						Id: conf.id,
						ItemNumber: conf.number,
						QuantityOrdered: conf.quantity_ordered,
						BaseNumber: conf.base_number,
						ImageUrl: conf.image_url,
					}))
				: null,
			ItemDescription: item.item_description,
			Items: item.is_pack
				? item.offerings.map(offering => ({
						Id: offering.id,
						PromoNoOfDays: offering.promo_no_of_days,
						PriceList: offering.price_list,
						Price: offering.price,
						ImageUrl: offering.image_url,
						BaseNumber: offering.base_number,
						Number: offering.number,
						Quantity: offering.quantity,
						OrderType: new OrderType().serialize(offering.order_type),
						Name: offering.db_item_name,
						IsConfigurable: offering.is_configurable,
						ItemDescription: offering.item_description,
						NetPrice: offering.net_price,
						EstShipDate: Cart.formatDate(offering.est_ship_date),
						PromoPrice: offering.promo_price,
						IsDropShipAllowed: offering.is_drop_ship_allowed,
					}))
				: null,
			CategoryShipTypeId: item.category_ship_type_id,
			CategoryShipTypeName: item.category_ship_type_name,
		};
	}
}



// WEBPACK FOOTER //
// ./src/api/models/Cart.js